/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCatEventPayloadDto
 */
export interface CreateCatEventPayloadDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCatEventPayloadDto
     */
    eventName: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateCatEventPayloadDto
     */
    fromDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateCatEventPayloadDto
     */
    toDate: Date;
    /**
     * 
     * @type {string}
     * @memberof CreateCatEventPayloadDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCatEventPayloadDto
     */
    description?: string;
}

/**
 * Check if a given object implements the CreateCatEventPayloadDto interface.
 */
export function instanceOfCreateCatEventPayloadDto(value: object): value is CreateCatEventPayloadDto {
    if (!('eventName' in value) || value['eventName'] === undefined) return false;
    if (!('fromDate' in value) || value['fromDate'] === undefined) return false;
    if (!('toDate' in value) || value['toDate'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    return true;
}

export function CreateCatEventPayloadDtoFromJSON(json: any): CreateCatEventPayloadDto {
    return CreateCatEventPayloadDtoFromJSONTyped(json, false);
}

export function CreateCatEventPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCatEventPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'eventName': json['eventName'],
        'fromDate': (new Date(json['fromDate'])),
        'toDate': (new Date(json['toDate'])),
        'country': json['country'],
        'description': json['description'] == null ? undefined : json['description'],
    };
}

export function CreateCatEventPayloadDtoToJSON(json: any): CreateCatEventPayloadDto {
    return CreateCatEventPayloadDtoToJSONTyped(json, false);
}

export function CreateCatEventPayloadDtoToJSONTyped(value?: CreateCatEventPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventName': value['eventName'],
        'fromDate': ((value['fromDate']).toISOString()),
        'toDate': ((value['toDate']).toISOString()),
        'country': value['country'],
        'description': value['description'],
    };
}

